import {
  AndJoint,
  Criteria,
  EqFilter,
  Expression,
  Filter,
  ICriteriaTranslator,
  InFilter,
  Joint,
  OrJoint,
  Pageable,
  Sort,
} from 'slipstream-components';

export default class SeciTranslator implements ICriteriaTranslator {
  public translateJointToPost(joint: Joint) {
    const jointKey = joint instanceof AndJoint ? 'and' : 'or';
    const filterPart = {};
    const filterItems = [];
    filterPart[jointKey] = filterItems;
    joint.filters.forEach((filter: Filter) => {
      if (filter instanceof Joint) {
        filterItems.push(this.translateJointToPost(filter));
      } else {
        const expression = filter as Expression;
        filterItems.push(this.translateExpressionToPost(expression));
      }
    });
    return filterPart;
  }
  public translateExpressionToPost(exp: Expression) {
    if (exp instanceof EqFilter) {
      let filterValues: any = typeof exp.value === 'string' ? exp.value.split(',') : [exp.value];
      if (filterValues.length === 1) {
        filterValues = filterValues[0];
      }

      const term = {
        filter: {
          key: exp.field,
          operator: exp.not ? 'NOT_EQUALS' : 'EQUALS',
          value: filterValues,
        },
      };
      return term;
    } else if (exp instanceof InFilter) {
      const term = {
        filter: {
          key: exp.field,
          operator: exp.not ? 'NOT_EQUALS' : 'EQUALS',
          value: exp.value,
        },
      };
      return term;
    }
    throw new Error('Method not implemented.');
  }
  public translateSortToPost(sort: Sort) {
    // it seems SD only support single sort.
    const order = sort.orders[0];
    return {
      order: order.direction === 'ascend' ? 'ascending' : 'descending',
      sort: order.field,
    };
  }
  public translatePageableToPost(pageable: Pageable) {
    return {
      from: (pageable.page - 1) * pageable.size,
      size: pageable.size,
    };
  }
  public translateJointToGet(joint: Joint) {
    throw new Error('Method not implemented.');
  }
  public translateExpressionToGet(expression: Expression) {
    throw new Error('Method not implemented.');
  }
  public translateSortToGet(sort: import('slipstream-components').Sort) {
    throw new Error('Method not implemented.');
  }
  public translatePageableToGet(pagable: import('slipstream-components').Pageable) {
    throw new Error('Method not implemented.');
  }
  public translateToPost(c: Criteria) {
    let filterPart = null;
    const filter = c.filter;
    if (c.filter) {
      filterPart = {
        filters: {
          and: [
            filter instanceof AndJoint || filter instanceof OrJoint
              ? this.translateJointToPost(filter)
              : this.translateExpressionToPost(filter as Expression),
          ],
        },
      };
    } else {
      filterPart = {};
    }

    if (c.pageable) {
      Object.assign(filterPart, this.translatePageableToPost(c.pageable));
    }
    if (c.sort) {
      Object.assign(filterPart, this.translateSortToPost(c.sort));
    }

    filterPart.detail = true;
    return filterPart;
  }
  public translateToGet(c: Criteria): string {
    throw new Error('Method not implemented.');
  }
}
